import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 44rem;
  padding: 1rem;
  background-color: #f9fafc;
  background: rgba(243, 243, 243, 0.5);
  border-radius: 4px 0px 0px 4px;
  border-right: 2px #53a1eb solid;
  @media (max-width: 1206px) {
    margin-left: 1rem;
  }
  @media (max-width: 784px) {
    width: 100%;
  }
  @media (max-width: 570px) {
    flex-direction: column;
    align-items: start;
  }
`;
